import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils/common";

function Title({title, color, align='center', align_md, className=''}) {
  if (!title) return null
  return (
    <div className={classNames(className, `max-w-4xl text-${align}`, align_md && `md:text-${align_md} mx-auto`)}>
      <span className={classNames(color ? 'text-primary': 'text-gray-900', 'mt-2 text-3xl tracking-tight sm:text-4xl font-medium font-brave-hunter')}>
        {title}
      </span>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string,
  color: PropTypes.bool,
  align: PropTypes.string,
  align_md: PropTypes.string,
  className: PropTypes.string,
};

export default Title;
